module.exports = __webpack_public_path__ + "static/media/g-14.0c82e667.jpg";